import React, { useEffect } from "react";
import { gtmEnvConfig } from "../../utils/gtmConfig";

const GoogleTagManager: React.FC = () => {
  const env = process.env.REACT_APP_ENV ?? "development";
  const gtmConfig = gtmEnvConfig[env];

  const authLink =
    "&gtm_auth=" + gtmConfig.gtmAuth + "&gtm_preview=" + gtmConfig.gtmPreview;

  const srcLink =
    "https://www.googletagmanager.com/ns.html?id=" + gtmConfig.gtmId + authLink;

  useEffect(() => {
    // Inserta el script de GTM
    (function (w: any, d: any, s: any, l: any, i: any) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      let f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l !== "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl + authLink;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", gtmConfig.gtmId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <noscript>
        <iframe
          title="gtm-title"
          src={srcLink}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>
  );
};

export default GoogleTagManager;
